var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 36 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,17.721c0,8.545-8.059,15.471-18,15.471a20.731,20.731,0,0,1-5.281-.677,33.274,33.274,0,0,1-9.407,2.727.577.577,0,0,1-.614-.8A23.214,23.214,0,0,0,4.43,27.886,14.245,14.245,0,0,1,0,17.721C0,9.176,8.059,2.25,18,2.25S36,9.176,36,17.721Zm-24.75,0A2.25,2.25,0,1,1,9,15.511,2.23,2.23,0,0,1,11.25,17.721Zm9,0A2.25,2.25,0,1,1,18,15.511,2.23,2.23,0,0,1,20.25,17.721ZM27,19.932a2.211,2.211,0,1,0-2.25-2.21A2.23,2.23,0,0,0,27,19.932Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.f1ecb31d514623390f1680674824a262.svg";
export { ForwardRef as ReactComponent };